import { LwFormInput } from 'redesign';
import { useFormContext } from 'react-hook-form';
import { Box, Divider, styled } from '@mui/material';
import { WorkflowCreateForm } from '../../workflow-create/workflow-create-toolbox/workflow-create-toolbox';

export const WorkflowEditToolbox = () => {
  const { control } = useFormContext<WorkflowCreateForm>();

  return (
    <Box marginBottom={4}>
      <StyledDivider />
      <StyledToolbox>
        <InputWrapper>
          <LwFormInput name="workflowName" control={control} label={'Workflow name'} disabled />
        </InputWrapper>
      </StyledToolbox>
    </Box>
  );
};

const StyledToolbox = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: theme.spacing(8),
  marginBottom: theme.spacing(4),
  marginTop: theme.spacing(4),
}));

const StyledDivider = styled(Divider)(({ theme }) => ({
  backgroundColor: theme.palette.lwPrimaryAccentDark[20],
}));

const InputWrapper = styled(Box)({
  display: 'flex',
  minWidth: 280,
});
